type Handler = (...args: unknown[]) => void;

export class EventBus {
  private listeners: Record<string, Handler[]> = {};

  on(event: string, handler: Handler) {
    this.listeners[event] ||= [];
    this.listeners[event].push(handler);
  }

  off(event: string, handler: Handler) {
    this.listeners[event] = this.listeners[event]?.filter(h => h !== handler) || [];
  }

  emit(event: string, ...args: unknown[]) {
    this.listeners[event]?.forEach(handler => handler(...args));
  }
}